import { render } from "./MagnifyMinusOutline.vue.js?vue&type=template&id=6b47cb72!=!../vue-loader/dist/index.js??ruleSet[0]!./MagnifyMinusOutline.vue?vue&type=template&id=6b47cb72"
import script from "./MagnifyMinusOutline.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./MagnifyMinusOutline.vue?vue&type=script&lang=js"
export * from "./MagnifyMinusOutline.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./MagnifyMinusOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__